import { FC, useCallback, useState } from 'react'
import { IndexCommon } from 'src/components/login/IndexCommon'
import { ConnectParamsQuery } from 'src/connect/params'
import {
  getServerSidePropsMiddlewareAddConnectParamsToProps,
  ServerSidePropsWithConnectParams,
} from 'src/connect/serverSideProps'
import { useConnectParams } from 'src/connect/useParams'
import { useHandleLoginNavigation } from 'src/hooks/loginNavigation/useHandleLoginNavigation'
import { useLoginErrorHandler } from 'src/hooks/loginNavigation/useLoginErrorHandler'
import { pagesPath } from 'src/routes/$path'
import { getLoginTitle } from 'src/utils/loginTitle'
import { usePagesLoginMutation } from './index.gen'

const FALLBACK_CLIENT_ID = 'pharmacy-support-web'
const REDIRECT_HOME_PATH = pagesPath.services.pharmacy_support_web.redirect_home.$url().pathname

const IndexPage: FC = () => {
  const handleLoginNavigation = useHandleLoginNavigation()
  const [locked, setLocked] = useState(false)
  const onAccountLocked = useCallback(() => setLocked(true), [])
  const handleLoginError = useLoginErrorHandler({ onAccountLocked })
  const { params } = useConnectParams()

  const [login, loginResult] = usePagesLoginMutation({
    onCompleted(data) {
      handleLoginNavigation(data.login)
    },
    onError: handleLoginError,
  })

  return (
    <IndexCommon
      loginTitle={getLoginTitle()}
      onSubmitEmailLogin={values => {
        const cookieLogin = params.cookieLogin ?? {
          clientId: FALLBACK_CLIENT_ID,
          redirectUri: `${window.location.origin}${REDIRECT_HOME_PATH}`,
        }
        login({
          variables: {
            input: {
              email: values.email,
              password: values.password,
              loginRequest: { cookieLogin },
            },
          },
        })
      }}
      submitting={loginResult.loading}
      locked={locked}
    />
  )
}

const Page: FC<ServerSidePropsWithConnectParams> = () => {
  return <IndexPage />
}

export type Query = ConnectParamsQuery

export const getServerSideProps = getServerSidePropsMiddlewareAddConnectParamsToProps()
export default Page
